import {Button, message, Modal} from 'antd';
import {CreateWebhookInput, useCreateWebhookMutation} from 'api/generated';
import {webhooksQuery} from 'api/queries';
import {AnchorLink} from 'components';
import {UrlInput} from 'components/Form/UrlInput';
import {Formik, FormikHelpers} from 'formik';
import {Form, FormItem, Switch, Select} from 'formik-antd';
import React, {useState} from 'react';
import * as yup from 'yup';
import {EventType} from 'types';
import {getWebhookEventTypes} from '../../lib/eventUtils';

export const CreateWebhook: React.FC<any> = ({
  accountId,
  masterAccount = false,
  settings = false
}) => {
  const [isOpen, setOpen] = useState(false);
  const [createWebhook] = useCreateWebhookMutation({
    updateQuery: {query: webhooksQuery, variables: {accountId}}
  });

  const webhookEventTypes = getWebhookEventTypes();

  const handleSubmit = async (
    input: CreateWebhookInput,
    {setSubmitting, resetForm}: FormikHelpers<CreateWebhookInput>
  ) => {
    try {
      await createWebhook({
        variables: {
          input: {
            ...input,
            masterAccount
          }
        }
      });
      setOpen(false);
      message.success('Webhook created successfully.');
      resetForm();
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = yup.object().shape({
    url: yup.string().url('URL is not valid').required('URL is required'),
    eventTypes: yup
      .array()
      .of(
        yup.string().oneOf(Object.keys(EventType)).required('At least one event type is required')
      )
      .min(1, 'At least one event type is required'),
    enabled: yup.boolean().required('Enabled status is required')
  });

  return (
    <>
      {settings ? (
        <Button type="primary" onClick={() => setOpen(true)}>
          Add new webhook
        </Button>
      ) : (
        <AnchorLink onClick={() => setOpen(true)}>Add new webhook</AnchorLink>
      )}
      <Formik<CreateWebhookInput>
        onSubmit={handleSubmit}
        initialValues={{
          accountId: accountId,
          url: '',
          eventTypes: [],
          enabled: true
        }}
        validationSchema={validationSchema}>
        {({handleSubmit, isSubmitting, resetForm}) => (
          <Modal
            open={isOpen}
            title={'Add new webhook'}
            okText={'Add'}
            cancelText={'Cancel'}
            confirmLoading={isSubmitting}
            onOk={() => handleSubmit()}
            onCancel={() => {
              setOpen(false);
              resetForm();
            }}>
            <Form layout="vertical">
              <FormItem hasFeedback={false} name="url" label={'URL'}>
                <UrlInput name="url" placeholder={'example.com'} />
              </FormItem>
              <FormItem hasFeedback={false} name="eventTypes" label={'Event Types'}>
                <Select
                  mode="multiple"
                  allowClear
                  placeholder={'Please select the event types'}
                  name="eventTypes"
                  options={webhookEventTypes}
                  optionFilterProp="label"
                />{' '}
              </FormItem>
              <FormItem hasFeedback={false} name="enabled" label={'Enabled'}>
                <Switch name="enabled" />
              </FormItem>
              <input type="submit" value={'submit'} hidden />
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
